function getWidth() {
    return Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );
  }
  
 
  console.log('Width:  ' +  getWidth() );


/* PRO LINE SLIDER*/
var testDistance =  getWidth();

var button = document.getElementById('pro-lineSlideForward');
button.onclick = function () {
    var slider = document.getElementById('pro-line-slider');
    sideScroll(slider,'right',25,testDistance,30);
    
};

var back = document.getElementById('pro-lineSlideBack');
back.onclick = function () {
    var slider = document.getElementById('pro-line-slider');

    sideScroll(slider,'left',25,testDistance,30);
    
};


function sideScroll(element,direction,speed,distance,step){

    scrollAmount = 0;
    var slideTimer = setInterval(function(){
        if(direction == 'left'){
            element.scrollLeft -= step;
        } else {
            element.scrollLeft += step;
        }
        scrollAmount += step;
        if(scrollAmount >= distance){
            window.clearInterval(slideTimer);
        }
    }, speed);
}


/*MUST HAVE SLIDER*/
var button = document.getElementById('musthavesSlideForward');

var galleryImg = document.getElementById('must-haves-1');
var galleryImgWidth = galleryImg.clientWidth;

function checkifDesktop(){
    if ((getWidth()) >= '1200'){
        var galleryDistance = galleryImgWidth;
    }
    else{
        var galleryDistance = (galleryImgWidth + (getWidth() - galleryImgWidth ));
    }
    return galleryDistance;
}
var galleryDistance = checkifDesktop();
console.log(galleryDistance);

button.onclick = function () {
    var slider = document.getElementById('must-haves-slider');
    sideScroll(slider,'right',30, galleryDistance,60);
};

var back = document.getElementById('musthavesSlideBack');
back.onclick = function () {
    var slider = document.getElementById('must-haves-slider');

    sideScroll(slider,'left',30,galleryDistance,60);
};

function sideScroll(element,direction,speed,distance,step){

    scrollAmount = 0;
    var slideTimer = setInterval(function(){
        if(direction == 'left'){
            element.scrollLeft -= step;
        } else {
            element.scrollLeft += step;
        }
        scrollAmount += step;
        if(scrollAmount >= distance){
            window.clearInterval(slideTimer);
        }
    }, speed);
}